// Filename: gani_uidom.js
// Timestamp: 2018.05.05-00:28:36 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import gnnodex from './gnnodex.js'

import {
  gnnodeChildKeysReset as nodeChildKeysReset,
  gnnodeAssign as nodeAssign
} from './gnnode.js'

import {
  gngraphNodeSet as graphNodeSet
} from './gngraph.js'

import {
  gnerr_nodechildnotfoundindex,
  gnerr_nodechildnotfoundvnode
} from './gnerr.js'

import {
  gnnodeosxVNodeGetFromKey as nodeosxVNodeGetFromKey
} from './gnnodeos.js'

import {
  gnenumKEY as KEY,
  gnenumISDOM as ISDOM,
  gnenumSPECNODENAMEKEY as SPECNODENAMEKEY,
  gnenumCHILDKEYNAME as CHILDKEYNAME,
  gnenumCHILDKEYSDOM as CHILDKEYSDOM
} from './gnenum.js'

// override to mutate or add default properties to spec
const xinit = nd => nodeAssign(nd, {
  [ISDOM]: true,
  [CHILDKEYNAME]: {},
  [CHILDKEYSDOM]: []
})

const xreset = nd => nodeChildKeysReset(nodeAssign(nd, {
  [CHILDKEYNAME]: {},
  [CHILDKEYSDOM]: []
}))

const vnnodeFromKey = nodeosxVNodeGetFromKey

const childVNodeGetFromName = (ss, cfg, gr, nd, ndname, required) => {
  const ndkey = nd.get(CHILDKEYNAME)[ndname]
  const vnode = ndkey && nodeosxVNodeGetFromKey(ss, cfg, gr, ndkey)

  if (!ndkey && required !== false)
    throw gnerr_nodechildnotfoundvnode(gr, nd, ndname)

  return vnode
}

const childVNodeGetFromIndex = (ss, cfg, gr, nd, i) => {
  const nodekey = nd.get(CHILDKEYSDOM)[i]
  const vnode = nodekey && nodeosxVNodeGetFromKey(ss, cfg, gr, nodekey)

  if (!nodekey || !vnode)
    throw gnerr_nodechildnotfoundindex(gr, nd, i)

  return vnode
}

// get _optional_ vnode for the child node at 'nodename'
const childVNodeGetFromNameOpt = (ss, cfg, gr, nd, nodename) => (
  childVNodeGetFromName(ss, cfg, gr, nd, nodename, false))

const childVNodesGet = (ss, cfg, gr, nd, fn) => nd
  .get(CHILDKEYSDOM)
  .map(key => typeof fn === 'function'
    ? fn(nodeosxVNodeGetFromKey(ss, cfg, gr, key))
    : nodeosxVNodeGetFromKey(ss, cfg, gr, key))

const xvnode = (ss, cfg, gr, nd, ndx) => (
  ndx.childVNodesGet(ss, cfg, gr, nd)[0])

// TODO rename (nodechilddomkeyset?)
const nodechilddomset = (ss, cfg, gr, pnode, cnode) => {
  const childkey = cnode.get(KEY)

  if (cnode.has(SPECNODENAMEKEY)) {
    // SPECNODENAMEKEY is a name definition which can be set by parent node
    // its name value will override the name defined in child-node's spec
    //
    // SPECNODENAMEKEY is then used to by parent to render the specific child
    // vnode, by name, within the parent's vnode
    // ```
    // div('.:pg-loadslate#:uid---loadslate', [
    //   ndx.childVNodeGetFromName(sess, cfg, graph, node, 'loadslate')])
    // ```
    pnode.get(CHILDKEYNAME)[cnode.get(SPECNODENAMEKEY)] = childkey
  } else {
    pnode.get(CHILDKEYSDOM).push(childkey)
  }

  return graphNodeSet(gr, pnode)
}

const xonchildadd = (ss, cfg, gr, nd, cnode) => {
  if (cnode.get(ISDOM)) {
    let res = nodechilddomset(ss, cfg, gr, nd, cnode)
    gr = res[0]
    nd = res[1]
  }

  return [gr, nd, cnode]
}

export default Object.assign({}, gnnodex, {
  type: 'gnnodexui',
  xinit,
  xreset,
  xvnode,
  xonchildadd,
  vnnodeFromKey,
  childVNodeGetFromName,
  childVNodeGetFromIndex,
  childVNodeGetFromNameOpt,
  childVNodesGet,
  nodechilddomset
})
